import { useMemo } from "react";
import { PSelect, Select } from "./Select";

type PCountriesSelect<T extends object> = {
  listOfValues: T[];
  value: PSelect["value"];
  onChange: PSelect["onChange"];
  label: string;
  color: string;
  baseColor: string;
  borderColor: string;
  expandedBorderColor?: string;
  onExpandedChange?: (expanded: boolean) => void;
  enableSearch?: boolean;
  description?: string;
};

interface IBaseCountries {
  id: number;
  country: string;
  countryImg: string;
}

export const CountriesDropdown = <T extends IBaseCountries>(
  props: PCountriesSelect<T> & { expanded?: boolean }
) => {
  const {
    listOfValues,
    value,
    onExpandedChange,
    onChange,
    label,
    color,
    baseColor,
    borderColor,
    expandedBorderColor,
    expanded,
    enableSearch = true,
    description,
  } = props;

  const options = useMemo(() => {
    return listOfValues.map((item) => ({
      label: (
        <div className="flex flex-row justify-between w-full">
          <div className="flex flex-row items-center gap-[4px]">
            <img
              src={item.countryImg}
              alt={item.country}
              height={16}
              width={16}
            />
            <span className="text-[12px]">{item.country}</span>
          </div>
        </div>
      ),
      value: item.id,
    }));
  }, [listOfValues]);

  return (
    <div className="flex flex-col space-y-[4px]">
      <Select
        label={label}
        options={options}
        value={value}
        color={color}
        borderColor={borderColor}
        baseColor={baseColor}
        expandedBorderColor={expandedBorderColor}
        expanded={expanded}
        onExpandedChange={onExpandedChange}
        onChange={(val: any) => onChange && onChange(val)}
        getOptionCls={(isActive: any) =>
          isActive
            ? "text-text-navbar-active text-[12px]"
            : "text-text-base text-[12px]"
        }
        enableSearch={enableSearch}
        searchableLabels={listOfValues.map((value) => [value.country])}
        optionsHeader={
          <div className="w-full flex flex-row justify-between text-grayscale-4 text-[12px] cursor-default"></div>
        }
      />
      {description && (
        <p className="text-text-subtle text-[10px] font-medium">
          {description}
        </p>
      )}
    </div>
  );
};
